import script from "./leagueView.vue?vue&type=script&lang=ts&setup=true"
export * from "./leagueView.vue?vue&type=script&lang=ts&setup=true"

import "./leagueView.vue?vue&type=style&index=0&id=426890ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426890ba"]])

export default __exports__